import React from 'react';
import { defaultNavigate, NavigationProvider } from './NavigationContext';

export const RouterNavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <NavigationProvider navigationImplementation={{ navigate: defaultNavigate }}>
      {children}
    </NavigationProvider>
  );
};
